import {Browser} from '@capacitor/browser';
import React from 'react';

type LinkedTextProps = {
    children: string;
    linkStyle?: React.CSSProperties;
    linkTarget?: string;
}

const defaultLinkStyle: React.CSSProperties = {
    color: '#0085FF',
    cursor: 'pointer',
    position: 'relative',
    zIndex: 10,
};

export const LinkedText: React.FC<LinkedTextProps> = ({children, linkStyle, linkTarget}) => {
    const regex = /%link\d+:(.*?)%(https?:\/\/.+?)%link\d+%/g

    const parseText = (text: string): (string | JSX.Element)[] => {
        const parts: (string | JSX.Element)[] = [];
        let lastIndex = 0;
        let match: RegExpExecArray | null;

        while ((match = regex.exec(text)) !== null) {
            const matchStart = match.index;
            const matchEnd = regex.lastIndex;

            if (matchStart > lastIndex) {
                parts.push(
                    <span key={'text-' + lastIndex} className="label-text" style={{position: "relative"}}>
                        {text.substring(lastIndex, matchStart)}
                    </span>
                );
            }

            const displayText = match[1];
            const url = match[2];

            parts.push(
                <span
                    className={'label-link'}
                    key={matchStart}
                    style={{
                        ...defaultLinkStyle,
                        ...linkStyle,
                    }}
                    onClick={(e) => {
                        if (!linkTarget) {
                            redirect(url);
                        }
                    }}
                >
                    {displayText}
                </span>
            );

            if (linkTarget) {
                handleLinkTargetOption(url);
            }

            lastIndex = matchEnd;
        }

        if (lastIndex < text.length) {
            parts.push(
                <span key={'text-' + lastIndex} className="label-text" style={{position: "relative"}}>
                    {text.substring(lastIndex)}
                </span>
            );
        }

        return parts;
    };

    const redirect = (url: string) => {
        Browser.open({url});
    }

    const handleLinkTargetOption = (url: string) => {
        const targetElement = document.querySelector('[data-link-target="' + linkTarget + '"]');

        if (targetElement && !(targetElement as HTMLElement).dataset.clickBound) {
            targetElement.addEventListener('click', function (e) {
                redirect(url);
            });

            (targetElement as HTMLElement).dataset.clickBound = 'true';
        }
    };

    return <>{parseText(children)}</>;
};